import DynamicPage from 'src/components/pages/DynamicPage';
import { IMicrositePageConfiguration } from 'src/interfaces/page';
import TopicPage from 'src/components/pages/TopicPage';
import Error from '../../../pages/_error';

export interface ResolvePageComponentProps {
  pageData?: IMicrositePageConfiguration;
  breadcrumbSkeletonCount?: number;
}

// Shared render switch for the CMS-driven page routes. Extracted verbatim from
// src/pages/[...urlSlug].tsx so src/pages/topic/[urlSlug].tsx can reuse the same
// resolved-or-404 behaviour instead of rendering TopicPage unconditionally.
// The 'Home'/'AppDetails' page types intentionally fall through to the 404
// branch — that is the pre-existing behaviour of the catch-all route, not a gap
// introduced here.
const ResolvePageComponent = ({
  pageData,
  breadcrumbSkeletonCount,
}: ResolvePageComponentProps) => {
  if (pageData?.pageType === 'Topic') {
    return (
      <TopicPage {...pageData} breadcrumbsCount={breadcrumbSkeletonCount} />
    );
  }

  if (pageData?.pageType === 'Dynamic') {
    return (
      <DynamicPage
        pageData={pageData}
        breadcrumbsCount={breadcrumbSkeletonCount}
      />
    );
  }

  return <Error statusCode={404} />;
};

export default ResolvePageComponent;
